"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var filter_tree_dto_1 = require("./filter-tree-dto");
var filter_dto_builder_1 = require("../builder/filter-dto-builder");
var filter_tree_operator_dto_1 = require("./filter-tree-operator-dto");
var in_filter_dto_1 = require("./in-filter-dto");
var time_period_filter_dto_1 = require("./time-period-filter-dto");
var is_filter_dto_1 = require("./is-filter-dto");
var exact_filter_dto_1 = require("./exact-filter-dto");
var contains_filter_dto_1 = require("./contains-filter-dto");
var starts_with_filter_dto_1 = require("./starts-with-filter-dto");
var ends_with_filter_dto_1 = require("./ends-with-filter-dto");
var category_range_filter_dto_1 = require("./category-range-filter-dto");
var measure_range_filter_dto_1 = require("./measure-range-filter-dto");
var top_filter_dto_1 = require("./top-filter-dto");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var is_current_user_filter_dto_1 = require("./is-current-user-filter-dto");
var is_specific_day_filter_dto_1 = require("./is-specific-day-filter-dto");
/**
 * Get FilterTreeDto from json file
 *
 * Created by Hayk.Andriasyan on 8/18/2017.
 */
var FilterTreeDtoFactory = /** @class */ (function () {
    function FilterTreeDtoFactory() {
    }
    FilterTreeDtoFactory.fromJson = function (filterJson) {
        idm_common_util_frontend_1.PreconditionCheck.notNull(filterJson);
        var filterObject = JSON.parse(filterJson);
        var tree;
        if (filterObject.rootOperator.children.length === 0) {
            tree = filter_dto_builder_1.FilterDtoBuilder.createAndFilterBuilder().build();
        }
        else {
            tree = new filter_tree_dto_1.FilterTreeDto();
            tree.rootOperator = FilterTreeDtoFactory.traverseFilterTreeJson(filterObject.rootOperator);
        }
        return tree;
    };
    FilterTreeDtoFactory.traverseFilterTreeJson = function (filterObject) {
        var treeElement;
        if (filterObject.type === filter_dto_builder_1.FilterDtoBuilder.OPERATOR) {
            var root = new filter_tree_operator_dto_1.FilterTreeOperatorDto(filter_dto_builder_1.FilterDtoBuilder.OPERATOR, filterObject.operator);
            var children = [];
            for (var _i = 0, _a = filterObject.children; _i < _a.length; _i++) {
                var child = _a[_i];
                var childFilterTreeDto = FilterTreeDtoFactory.traverseFilterTreeJson(child);
                children.push(childFilterTreeDto);
            }
            root.children = children;
            treeElement = root;
        }
        else {
            treeElement = FilterTreeDtoFactory.getFilterDto(filterObject);
        }
        return treeElement;
    };
    FilterTreeDtoFactory.getFilterDto = function (filterJson) {
        if (!(filterJson.filterType in FilterTreeDtoFactory.filterTypeDelegate)) {
            console.error('Unknown filter type ' + filterJson.filterType);
            throw new Error('Unknown filter type ' + filterJson.filterType);
        }
        return FilterTreeDtoFactory.filterTypeDelegate[filterJson.filterType](filterJson);
    };
    FilterTreeDtoFactory.inFilter = function (filterObject) {
        var filterType = filter_dto_builder_1.FilterDtoBuilder.IN;
        var values = filterObject.values;
        if (values.length === 1 && !values[0]) {
            filterType = filter_dto_builder_1.FilterDtoBuilder.UNSPECIFIED;
        }
        var inFilterDto = new in_filter_dto_1.InFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterType, filterObject.onCategoryPathHolderId);
        inFilterDto.values = values;
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(inFilterDto, filterObject);
        return inFilterDto;
    };
    FilterTreeDtoFactory.isCurrentUser = function (filterObject) {
        var filterDto = new is_current_user_filter_dto_1.IsCurrentUserFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterObject.filterType, filterObject.onCategoryPathHolderId);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filterDto, filterObject);
        return filterDto;
    };
    FilterTreeDtoFactory.isSpecificDay = function (filterObject) {
        var filterDto = new is_specific_day_filter_dto_1.IsSpecificDayFilterDto(filterObject.onMeasurePathHolderId, filterObject.value);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filterDto, filterObject);
        return filterDto;
    };
    FilterTreeDtoFactory.timePeriodFilter = function (filterObject) {
        var filterDto = new time_period_filter_dto_1.TimePeriodFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterObject.filterType, filterObject.onCategoryPathHolderId, filterObject.value);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filterDto, filterObject);
        return filterDto;
    };
    FilterTreeDtoFactory.is = function (filterObject) {
        var filter;
        filter = typeof filterObject.onMeasurePathHolderId === 'undefined' ?
            new is_filter_dto_1.IsFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterObject.filterType, filterObject.onCategoryPathHolderId, filterObject.value) :
            new exact_filter_dto_1.ExactFilterDto(filterObject.onMeasurePathHolderId, filterObject.value, filterObject.currencyId, filterObject.byCategoryPathHolderId);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filter, filterObject);
        return filter;
    };
    FilterTreeDtoFactory.contains = function (filterObject) {
        var filter = new contains_filter_dto_1.ContainsFilterDto(filterObject.pathHolderId, filterObject.value);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filter, filterObject);
        return filter;
    };
    FilterTreeDtoFactory.startsWith = function (filterObject) {
        var filter = new starts_with_filter_dto_1.StartsWithFilterDto(filterObject.pathHolderId, filterObject.value);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filter, filterObject);
        return filter;
    };
    FilterTreeDtoFactory.endsWith = function (filterObject) {
        var filter = new ends_with_filter_dto_1.EndsWithFilterDto(filterObject.pathHolderId, filterObject.value);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filter, filterObject);
        return filter;
    };
    FilterTreeDtoFactory.between = function (filterObject) {
        var betweenFilter;
        if (typeof filterObject.onCategoryPathHolderId === 'undefined') {
            betweenFilter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filterObject.filterType, filterObject.onMeasurePathHolderId, filterObject.valueFrom, filterObject.valueTo, filterObject.inclusive, filterObject.currencyId, filterObject.byCategoryPathHolderId);
        }
        else {
            betweenFilter = new category_range_filter_dto_1.CategoryRangeFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterObject.filterType, filterObject.onCategoryPathHolderId, filterObject.valueFrom, filterObject.valueTo, filterObject.inclusive);
        }
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(betweenFilter, filterObject);
        return betweenFilter;
    };
    FilterTreeDtoFactory.rangeFilter = function (filterObject) {
        var filter;
        var valueFrom;
        var valueTo;
        if (filterObject.filterType === 'greaterThan' || filterObject.filterType === 'greaterThanOrEqual') {
            valueFrom = filterObject.valueFrom;
            valueTo = null;
        }
        else {
            valueFrom = null;
            valueTo = filterObject.valueTo;
        }
        filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filterObject.filterType, filterObject.onMeasurePathHolderId, valueFrom, valueTo, filterObject.inclusive, filterObject.currencyId, filterObject.byCategoryPathHolderId);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filter, filterObject);
        return filter;
    };
    FilterTreeDtoFactory.dateRangeFilter = function (filterObject) {
        var filter;
        var valueFrom;
        var valueTo;
        if (filterObject.filterType === 'before' || filterObject.filterType === 'onOrBefore') {
            valueFrom = null;
            valueTo = filterObject.valueTo;
        }
        else {
            valueFrom = filterObject.valueFrom;
            valueTo = null;
        }
        if (typeof filterObject.onCategoryPathHolderId === 'undefined') {
            filter = new measure_range_filter_dto_1.MeasureRangeFilterDto(filterObject.filterType, filterObject.onMeasurePathHolderId, valueFrom, valueTo, filterObject.inclusive, filterObject.currencyId, filterObject.byCategoryPathHolderId);
        }
        else {
            filter = new category_range_filter_dto_1.CategoryRangeFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filterObject.filterType, filterObject.onCategoryPathHolderId, valueFrom, valueTo, filterObject.inclusive);
        }
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(filter, filterObject);
        return filter;
    };
    FilterTreeDtoFactory.top = function (filterObject) {
        var topFilter = new top_filter_dto_1.TopFilterDto(filter_dto_builder_1.FilterDtoBuilder.FILTER, filter_dto_builder_1.FilterDtoBuilder.TOP, filterObject.onCategoryPathHolderId, filterObject.topCount, filterObject.byMeasurePathHolderId);
        FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser(topFilter, filterObject);
        return topFilter;
    };
    FilterTreeDtoFactory.setFilterExcludedAndIsHiddenForUser = function (filterDto, filterObject) {
        filterDto.excluded = filterObject.excluded;
        filterDto.isHiddenForUser = filterObject.isHiddenForUser;
    };
    /**
     * Key is filter type, value is filter's type creator method
     */
    FilterTreeDtoFactory.filterTypeDelegate = {
        'in': FilterTreeDtoFactory.inFilter,
        'unspecified': FilterTreeDtoFactory.inFilter,
        'isCurrentUser': FilterTreeDtoFactory.isCurrentUser,
        'isCurrent': FilterTreeDtoFactory.timePeriodFilter,
        'isSpecificDay': FilterTreeDtoFactory.isSpecificDay,
        'isLast': FilterTreeDtoFactory.timePeriodFilter,
        'isNext': FilterTreeDtoFactory.timePeriodFilter,
        'is': FilterTreeDtoFactory.is,
        'exact': FilterTreeDtoFactory.is,
        'contains': FilterTreeDtoFactory.contains,
        'startsWith': FilterTreeDtoFactory.startsWith,
        'endsWith': FilterTreeDtoFactory.endsWith,
        'between': FilterTreeDtoFactory.between,
        'betweenDates': FilterTreeDtoFactory.between,
        'greaterThan': FilterTreeDtoFactory.rangeFilter,
        'greaterThanOrEqual': FilterTreeDtoFactory.rangeFilter,
        'lessThan': FilterTreeDtoFactory.rangeFilter,
        'lessThanOrEqual': FilterTreeDtoFactory.rangeFilter,
        'before': FilterTreeDtoFactory.dateRangeFilter,
        'onOrBefore': FilterTreeDtoFactory.dateRangeFilter,
        'after': FilterTreeDtoFactory.dateRangeFilter,
        'onOrAfter': FilterTreeDtoFactory.dateRangeFilter,
        'top': FilterTreeDtoFactory.top,
    };
    return FilterTreeDtoFactory;
}());
exports.FilterTreeDtoFactory = FilterTreeDtoFactory;
//# sourceMappingURL=filter-tree-dto-factory.js.map